import { rachelMediaArray } from './rachelMedia'
import { rachelBio } from './rachelBios'
import { monicaProfileReviewHinge, rossProfileReviewBumble, joeyProfileReviewTinder } from './rachelProfileReviews'

export const rachelDatingProfileHinge = {
  _id: 'rachelDatingProfileHingeId',
  userId: 'rachelUserId',
  email: 'rachel@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...monicaProfileReviewHinge }
  ],
  mediaItems: [ ...rachelMediaArray ],
  bioItems: { ...rachelBio },
}

export const rachelDatingProfileBumble = {
  _id: 'rachelDatingProfileBumbleId',
  userId: 'rachelUserId',
  email: 'rachel@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: rachelBio.aboutMe[0],
    hobbies: [rachelBio.hobbies[0], rachelBio.hobbies[1], rachelBio.hobbies[2], rachelBio.hobbies[3], rachelBio.hobbies[4] ],
  },
  profileReviews: [
    { ...rossProfileReviewBumble }
  ],
  mediaItems: [ ...rachelMediaArray ],
  bioItems: { ...rachelBio },
}

export const rachelDatingProfileTinder = {
  _id: 'rachelDatingProfileTinderId',
  userId: 'rachelUserId',
  email: 'rachel@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: rachelMediaArray[12]._id,
      mediaItemURL: rachelMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[12].type,
      caption: rachelMediaArray[12].captions[0],
      subcaption: rachelMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[18]._id,
      mediaItemURL: rachelMediaArray[18].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[18].type,
      caption: rachelMediaArray[18].captions[1],
      subcaption: rachelMediaArray[18].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[6]._id,
      mediaItemURL: rachelMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[6].type,
      caption: rachelMediaArray[6].captions[1],
      subcaption: rachelMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[7]._id,
      mediaItemURL: rachelMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[7].type,
      caption: rachelMediaArray[7].captions[1],
      subcaption: rachelMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[4]._id,
      mediaItemURL: rachelMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[4].type,
      caption: rachelMediaArray[4].captions[2],
      subcaption: rachelMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: rachelMediaArray[19]._id,
      mediaItemURL: rachelMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: rachelMediaArray[19].type,
      caption: rachelMediaArray[19].captions[2],
      subcaption: rachelMediaArray[19].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: rachelBio._id,
    vitalInfo: { ...rachelBio.vitalInfo },
    prompts: [
      { ...rachelBio.prompts[0] },
      { ...rachelBio.prompts[1] },
      { ...rachelBio.prompts[2] }
    ],
    aboutMe: rachelBio.aboutMe[0],
    hobbies: [rachelBio.hobbies[0], rachelBio.hobbies[1], rachelBio.hobbies[2], rachelBio.hobbies[3], rachelBio.hobbies[4] ],
  },
  profileReviews: [
    { ...joeyProfileReviewTinder }
  ],
  mediaItems: [ ...rachelMediaArray ],
  bioItems: { ...rachelBio },
}